import { ChevronUp, ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";

export function SortableHeader({ 
  children, 
  field, 
  currentSort, 
  onSort, 
  className = "",
  align = "left" 
}) {
  const isActive = currentSort?.field === field;
  const isAsc = isActive && currentSort?.direction === "asc";
  const isDesc = isActive && currentSort?.direction === "desc";

  const handleClick = () => {
    if (!isActive || isDesc) {
      onSort({ field, direction: "asc" });
    } else {
      onSort({ field, direction: "desc" });
    }
  };

  return (
    <div 
      className={cn(
        "flex items-center gap-1 cursor-pointer select-none hover:text-foreground transition-colors group",
        align === "right" && "justify-end",
        align === "center" && "justify-center",
        className
      )}
      onClick={handleClick}
    >
      <span className={cn(isActive && "text-primary font-medium")}>
        {children}
      </span>
      <div className="flex flex-col -space-y-1">
        <ChevronUp 
          className={cn(
            "h-3 w-3 transition-colors",
            isAsc 
              ? "text-primary" 
              : "text-muted-foreground/40 group-hover:text-muted-foreground"
          )} 
        />
        <ChevronDown 
          className={cn(
            "h-3 w-3 transition-colors",
            isDesc 
              ? "text-primary" 
              : "text-muted-foreground/40 group-hover:text-muted-foreground"
          )} 
        />
      </div>
    </div>
  );
}

// Helper function to sort data
export function sortData(data, sort) {
  if (!sort || !sort.field) return data;
  
  return [...data].sort((a, b) => {
    let aVal = a[sort.field];
    let bVal = b[sort.field];
    
    // Handle null/undefined
    if (aVal == null) aVal = "";
    if (bVal == null) bVal = "";
    
    // Handle numbers
    if (typeof aVal === "number" && typeof bVal === "number") {
      return sort.direction === "asc" ? aVal - bVal : bVal - aVal;
    }
    
    // Handle dates (format: DD-MM-YYYY or YYYY-MM-DD)
    const dateRegex = /^\d{2}-\d{2}-\d{4}$|^\d{4}-\d{2}-\d{2}$/;
    if (dateRegex.test(String(aVal)) && dateRegex.test(String(bVal))) {
      const parseDate = (str) => {
        if (str.includes("-")) {
          const parts = str.split("-");
          if (parts[0].length === 4) {
            // YYYY-MM-DD
            return new Date(parts[0], parts[1] - 1, parts[2]);
          } else {
            // DD-MM-YYYY
            return new Date(parts[2], parts[1] - 1, parts[0]);
          }
        }
        return new Date(str);
      };
      const dateA = parseDate(aVal);
      const dateB = parseDate(bVal);
      return sort.direction === "asc" ? dateA - dateB : dateB - dateA;
    }
    
    // Handle strings
    const strA = String(aVal).toLowerCase();
    const strB = String(bVal).toLowerCase();
    
    if (sort.direction === "asc") {
      return strA.localeCompare(strB, "it");
    } else {
      return strB.localeCompare(strA, "it");
    }
  });
}
